import { RideAssignmentEffects } from './ride-assignment.effects';

export const rideAssignmentFeatureEffects = [RideAssignmentEffects];
